import MapBase from './mapBase';

class WaybillMap extends MapBase {
    // 初始化地图
    initMap (options = {}) {
        this.map.clearOverlays();
        this.setViewport();
    }

    // 设置地图最佳视角
    setViewport () {
        const overlays = this.map.getOverlays();
        const points = overlays.flatMap(overflow => {
            if (Array.isArray(overflow.points)) {
                return overflow.points.map(p => p.latLng);
            }
            return [overflow.latLng];
        });
        this.map.setViewport(points);
    }
}

export default WaybillMap;
